import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  createElement,
  useMemo,
} from "react";
import axios from "axios";
import BASE_URL from "../../assets/global/url";
import {
  Modal,
  Button,
  Form,
  Table,
  OverlayTrigger,
  Tooltip,
  Tab,
  Tabs,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import { customStyles } from "../../assets/table-style";
import "@fortawesome/fontawesome-free/css/all.min.css";
import swal from "sweetalert";
import { validateCheckNumbers } from "../../utils/checkNumberValidator";
import CheckNumberError from "../../components/inputs/CheckNumberError";
// csv
import { CSVLink } from "react-csv";
import { ThreeDot } from "react-loading-indicators";
import NoAccess from "../../assets/img/NoAccess.png";
import useDecodeToken from "../../hooks/customHook/useDecodeToken";
import DatePicker from "react-datepicker";
import {
  format,
  parse as parseDateFns,
  isValid as isValidDateFns,
} from "date-fns";
import { PaginationControls } from "../../hooks/customHook/paginationHook/usePagination";
import { useServerPagination } from "../../hooks/customHook/paginationHook/useServerPagination";
import { useServerSort } from "../../hooks/customHook/sortingHook/useTableSort";
import Select from "react-select";
import { selectCustomStyles } from "../../assets/global/selectCustomStyles";
import useDarkMode from "../../components/Themes/Usedarkmode";
import {
  compactNumberFormat,
  formatToTwoDecimal,
  currencySymbol,
} from "../../utils/numberFormatter";
import { CustomDatePickerHeader } from "../../components/CustomDatePicker";
import TypedDateInput, {
  DATE_DISPLAY_FORMAT,
  DATE_PICKER_FORMATS,
} from "../../components/inputs/TypedDateInput";
import {
  checkCutoffDate,
  warnIfNoCutoff,
} from "../../utils/cutoffDateValidation";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import CollectionPdf from "./components/pdf/CollectionPdf";
import CollectionCsv from "./components/csv/CollectionCsv";
import DateRangePicker from "../../components/DateRangePicker";
// import { Tab, Tabs } from "react-bootstrap";
// import { useMemo } from "react";
import { getMonthBoundaries, initializeCutoff } from "../../utils/newdate";
import FilterStore from "../../hooks/customHook/FilterStore";

// Receiving Check modal: typed Transaction Date / Issued Date must follow
// MM/dd/yyyy (e.g. 10/08/2026). Same rules as Invoice Date in create_invoice.jsx:
// slashes are added automatically; anything that is not a valid prefix of that
// format (letters, extra digits, other date formats) is rejected and the input
// keeps its previous text. Returns the masked text, or null when the keystroke
// was rejected.
const RECEIVING_CHECK_DATE_FORMAT = "MM/dd/yyyy";

const maskTypedDate = (e) => {
  const raw = e?.target?.value;
  if (typeof raw !== "string") return null;

  const next = raw
    .replace(/^(\d{2})(\d)/, "$1/$2")
    .replace(/^(\d{2}\/\d{2})(\d)/, "$1/$2");

  if (!/^(\d{0,2}|\d{2}\/\d{0,2}|\d{2}\/\d{2}\/\d{0,4})$/.test(next)) {
    e.preventDefault();
    return null;
  }
  e.target.value = next;
  return next;
};

// Typed text that is a complete MM/dd/yyyy date -> that day as a Date (start of
// day). Anything else (still typing, or an impossible date like 02/31/2026) -> null.
const parseCompleteTypedDate = (text) => {
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(text)) return null;
  const typed = parseDateFns(text, RECEIVING_CHECK_DATE_FORMAT, new Date());
  if (!isValidDateFns(typed)) return null;
  typed.setHours(0, 0, 0, 0);
  return typed;
};

const Collection = ({ authrztn }) => {
  const { themeSelectStyles } = useDarkMode();
  const themedSelectStyles = (...args) =>
    themeSelectStyles(selectCustomStyles(...args));
  const userLoggedID = useDecodeToken();
  const csvLinkRef = useRef();
  const pageRestored = useRef(false);
  const [printToPdf, setPrintToPdf] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [validated, setValidated] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // ------------- Improved Filters State w/ Lazy Initialization from FilterStore -------------
  const [searchText, setSearchText] = useState(() => FilterStore.OCgetSearch());
  useEffect(() => {
    FilterStore.OCsaveSearch(searchText);
  }, [searchText]);
  const [filterColumn, setFilterColumn] = useState(() =>
    FilterStore.OCgetFilterColumn(),
  );
  useEffect(() => {
    FilterStore.OCsaveFilterColumn(filterColumn);
  }, [filterColumn]);
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = FilterStore.getTab();
    return ["pending", "collected"].includes(savedTab) ? savedTab : "pending";
  });
  const [selectedAccount, setSelectedAccount] = useState(() => {
    const saved = FilterStore.getSelected();
    // Default to null if it's the empty array fallback from FilterStore
    return Array.isArray(saved) && saved.length === 0 ? null : saved;
  });

  const [selectedCutOff, setSelectedCutOff] = useState("");
  const [cutOffDate, setCutOffDate] = useState("");
  // ------------------------------------------------------------------------------

  const [collectionsData, setCollectionsData] = useState([]);
  const [modalSubject, setModalSubject] = useState(false);
  const [subject1, setSubject1] = useState("");
  const [subject2DataList, setSubject2DataList] = useState([]);
  const [subject2, setSubject2] = useState("");
  const [subject3DataList, setSubject3DataList] = useState([]);
  const [subject3, setSubject3] = useState("");
  const [isSubject2Disabled, setIsSubject2Disabled] = useState(true);
  const [isSubject3Disabled, setIsSubject3Disabled] = useState(true);
  const [currencySelectedId, setCurrencyId] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedRowIssuedDate, setSelectedRowIssuedDate] = useState(null);
  const [transactionNumber, setTransactionNumber] = useState(null);
  const [issuedCheckNumber, setIssuedCheckNumber] = useState(null);
  const [selectedBulkCollectionId, setSelectedBulkCollectionId] =
    useState(null);
  // const [selectedCutOff, setSelectedCutOff] = useState(""); // state for input select
  // const [cutOffs, setCutOffs] = useState([]); // state for all cut off
  // const [cutOffDate, setCutOffDate] = useState(""); // state for input date
  const [widget, setWidget] = useState({});
  const [accountListSub3, setAccountListSub3] = useState([]);
  // const selectedAccount = useRef("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const [currencyRate, setCurrencyRate] = useState("");
  const [paymentData, setPaymentData] = useState({});

  // --- Pay Date Modal (shown before Collect) ---
  const [showDateModal, setShowDateModal] = useState(false);
  const [selectedClaimDate, setSelectedClaimDate] = useState("");
  const [pendingCollectRow, setPendingCollectRow] = useState(null);
  const [unpostedCutoff, setUnpostedCutoff] = useState(null);
  const [claimDateError, setClaimDateError] = useState("");
  // --------------------------------------------------

  const [claimType, setClaimType] = useState("");
  const [collectionCheckRowData, setCollectionCheckRowData] = useState([]);
  const [isNotPhp, setIsNotPhp] = useState(false);
  const [showReceivingCheckModal, setShowReceivingCheckModal] = useState(false);
  const [subject2LoanDataList, setSubject2LoanDataList] = useState([]);
  const [subject3LoanDataList, setSubject3LoanDataList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [loanData, setLoanData] = useState({
    issuedDate: "",
    transactionDate: "",
    subject1: "Liabilities Account",
    subject2: "",
    subject2_name: "",
    subject3: "",
    subject3_name: "",
    checkNumber: "",
    amount: "",
    remarks: "",
    currency_id: "",
    currency_name: "",
  });

  const [issuedDateError, setIssuedDateError] = useState("");
  const [postedCutoffs, setPostedCutoffs] = useState([]);

  const [isFromSalesCollection, setIsFromSalesCollection] = useState(false);
  const [isVisibleLiabNote, setIsVisibleLiabNote] = useState(false);
  const [pendingTabCount, setPendingTabCount] = useState(0);
  const [collectedTabCount, setCollectedTabCount] = useState(0);
  //for loan
  // const [showAddLoanModal, setShowAddLoanModal] = useState(false);

  const pagination = useServerPagination(
    BASE_URL + "/outstanding/getOutstandingCollectionData",
    FilterStore.OCgetPerPage(),
    (() => {
      const saved = FilterStore.get();
      const boundaries = saved || getMonthBoundaries();
      const cutoff = initializeCutoff(boundaries);
      return {
        dateFrom: cutoff?.from,
        dateTo: cutoff?.to,
        filterColumn: FilterStore.OCgetFilterColumn(),
        searchText: FilterStore.OCgetSearch() || "",
        accountId: (() => {
          const sel = FilterStore.getSelected();
          return Array.isArray(sel) && sel.length === 0
            ? null
            : sel?.value || null;
        })(),
      };
    })(),
  );

  // No initial sortBy: the backend default (newest first) has no visible column,
  // so every header starts neutral until the user picks one
  const sort = useServerSort(pagination);

  // --- Page / PerPage retention ---
  // Save page — gated behind pageRestored so the hook's internal reset-to-1
  // from the debounced updateParams on mount doesn't clobber the stored page.
  useEffect(() => {
    if (!pageRestored.current) return;
    if (pagination.currentPage) {
      FilterStore.OCsavePage(pagination.currentPage);
    }
  }, [pagination.currentPage]);

  useEffect(() => {
    if (pagination.itemsPerPage) {
      FilterStore.OCsavePerPage(pagination.itemsPerPage);
    }
  }, [pagination.itemsPerPage]);

  // Restore last viewed page on mount. The centralized useEffect has a 500ms
  // debounce that fires updateParams (resetting page to 1) ~500ms after mount.
  // setTimeout(600) ensures the restore always fires AFTER that debounce, so
  // setCurrentPage(savedPage) is the last write and isn't clobbered.
  useEffect(() => {
    const savedPage = FilterStore.OCgetPage();
    if (savedPage > 1) {
      setTimeout(() => {
        pagination.setCurrentPage(savedPage);
        pageRestored.current = true;
      }, 600);
    } else {
      setTimeout(() => {
        pageRestored.current = true;
      }, 600);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------- CENTRALIZED useEffect ----------
  useEffect(() => {
    // Check FilterStore for saved dates first
    const savedDates = FilterStore.get();
    let initialCutoff;

    if (savedDates) {
      initialCutoff = savedDates;
    } else {
      const boundaries = getMonthBoundaries();
      initialCutoff = initializeCutoff(boundaries);
    }

    setSelectedCutOff(initialCutoff);
    setCutOffDate(initialCutoff);

    fetchAccountListSub3ForSelect();
    fetchCurrencyList();
    fetchSubject2Data("Liabilities Account");
  }, []);

  // --- Debounced API Fetch Effect (Listens to all filters) ---
  useEffect(() => {
    const timer = setTimeout(() => {
      if (selectedCutOff || cutOffDate) {
        const currentCutoff = selectedCutOff || cutOffDate;

        pagination.updateParams({
          dateFrom: currentCutoff?.from,
          dateTo: currentCutoff?.to,
          accountId: selectedAccount?.value || null,
          filterColumn: filterColumn,
          searchText: searchText,
          status: activeTab === "pending" ? "Approved" : "Claimed",
        });
        setIsLoading(false);
      }
    }, 500);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedCutOff,
    cutOffDate,
    selectedAccount,
    filterColumn,
    searchText,
    activeTab,
    refreshKey,
  ]);

  useEffect(() => {
    const { data, totalClaimed, totalUnclaimed, totalPending, totalCollected } =
      pagination.data;
    setWidget((prev) => ({
      ...prev,
      totalClaimed: totalClaimed,
      totalUnclaimed: totalUnclaimed,
    }));
    if (totalPending !== undefined) setPendingTabCount(totalPending);
    if (totalCollected !== undefined) setCollectedTabCount(totalCollected);
    setCollectionsData(data || []);
  }, [pagination.data]);
  // --------------------------------------------------------

  const handleCloseReceivingCheckModal = () => {
    setShowReceivingCheckModal(false);
    setLoanData({
      issuedDate: "",
      transactionDate: "",
      subject1: "Liabilities Account",
      subject2: "",
      subject2_name: "",
      subject3: "",
      subject3_name: "",
      checkNumber: "",
      amount: "",
      remarks: "",
      currency_id: "",
      currency_name: "",
    });
    fetchSubject2Data("Liabilities Account");
    setValidated(false);
    setIssuedDateError("");
  };

  // Receiving Check: posted cutoffs, re-fetched each time the modal opens so a
  // cutoff posted in the meantime is picked up
  const fetchPostedCutoffs = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/invoice/getCutoffPosted`);
      setPostedCutoffs(res.data || []);
    } catch (error) {
      console.error(error);
      setPostedCutoffs([]);
    }
  };

  // The posted cutoff that the Transaction Date falls in, or null
  const transactionDatePostedCutoff = useMemo(() => {
    if (!loanData.transactionDate) return null;
    const day = format(new Date(loanData.transactionDate), "yyyy-MM-dd");
    return (
      postedCutoffs.find((cutoff) => {
        const from = String(cutoff.from).slice(0, 10);
        const to = String(cutoff.to).slice(0, 10);
        return day >= from && day <= to;
      }) || null
    );
  }, [loanData.transactionDate, postedCutoffs]);

  // Receiving Check: Transaction Date picked from the calendar, typed, or "Today".
  // Warns when the date is in a posted cutoff or has no cutoff yet (the posted
  // note below the field and the disabled Save button stay as well).
  const handleLoanTransactionDateChange = (date) => {
    // Replaced by checkCutoffDate (utils/cutoffDateValidation)
    // if (date) {
    //   dateValidation(date, setLoanData, "Transaction Date", "transactionDate");
    // }
    if (date) checkCutoffDate(date, "Transaction Date");
    setLoanTransactionDate(date);
  };

  // Sets the Transaction Date without the cutoff warning (default date on open)
  const setLoanTransactionDate = (date) => {
    setIssuedDateError("");
    // If the new Transaction Date is later than the currently selected Issued
    // Date, push Issued Date forward to match — Issued Date can never be
    // earlier than Transaction Date.
    setLoanData((prev) => {
      const currentIssuedDate = prev.issuedDate
        ? new Date(prev.issuedDate)
        : null;
      return {
        ...prev,
        transactionDate: date || "",
        issuedDate:
          date && currentIssuedDate && date > currentIssuedDate
            ? date
            : prev.issuedDate,
      };
    });
  };

  // Receiving Check: Issued Date picked from the calendar, typed, or "Today"
  const handleLoanIssuedDateChange = (date) => {
    // Replaced by warnIfNoCutoff (utils/cutoffDateValidation)
    // if (date) {
    //   dateValidation(date, setLoanData, "Issued Date", "issuedDate");
    // }
    if (date) warnIfNoCutoff(date, "Issued Date");
    setIssuedDateError("");
    setLoanData((prev) => ({ ...prev, issuedDate: date || "" }));
  };

  // A complete typed Issued Date earlier than the Transaction Date is silently
  // ignored by react-datepicker (minDate makes that day disabled): onChange
  // never fires, the old date stays selected and the text snaps back on blur.
  // Flag it here and drop the stale selection so it can't be saved by mistake.
  const handleLoanIssuedDateRaw = (e) => {
    const next = maskTypedDate(e);
    if (next === null) return;

    const typed = parseCompleteTypedDate(next);
    if (!typed || !loanData.transactionDate) {
      setIssuedDateError("");
      return;
    }
    const minIssued = new Date(loanData.transactionDate);
    minIssued.setHours(0, 0, 0, 0);
    if (typed < minIssued) {
      setLoanData((prev) => ({ ...prev, issuedDate: "" }));
      setIssuedDateError(
        `Issued date cannot be earlier than the transaction date (${format(minIssued, DATE_DISPLAY_FORMAT)}).`,
      );
      return;
    }
    setIssuedDateError("");
  };

  // ----------- Commented for revision -----------
  // const handleCutoffChange = (value) => {
  //   let filteredCutoff;
  //   if (value === "All Cutoff" || !value) {
  //     const ascendingSortedCutoff = cutOffs.sort(
  //       (a, b) => new Date(b.from) - new Date(a.from)
  //     );
  //     filteredCutoff = {
  //       from: ascendingSortedCutoff[ascendingSortedCutoff.length - 1]?.from,
  //       to: ascendingSortedCutoff[0]?.to,
  //     };
  //   } else {
  //     [filteredCutoff] = cutOffs.filter((item) => {
  //       return item.id == value;
  //     });
  //   }
  //   return filteredCutoff;
  // };

  // handle change select cutoff date
  // const handleSelectAccount = (selectedOption) => {
  //   setSelectedAccount(selectedOption);
  //   pagination.setCurrentPage(1);
  // };
  // --------------------------------------------------------

  // ------------------ New handlers ----------------------
  const handleDateRangeChange = (startDate, endDate) => {
    const cutoff = {
      id: "custom",
      from: startDate,
      to: endDate,
    };
    setSelectedCutOff(cutoff);
    setCutOffDate(cutoff);
    pagination.setCurrentPage(1);

    FilterStore.save(startDate, endDate);
  };

  const handleSelectAccount = (selectedOption) => {
    setSelectedAccount(selectedOption);
    pagination.setCurrentPage(1);

    FilterStore.saveSelected(selectedOption || null);
  };

  const handleClearFilters = () => {
    const boundaries = getMonthBoundaries();
    const initialCutoff = initializeCutoff(boundaries);

    FilterStore.clear();
    FilterStore.OCsaveSearch("");
    FilterStore.saveTab("pending"); // Reset tab in storage

    setSelectedAccount(null);
    setSelectedCutOff(initialCutoff);
    setCutOffDate(initialCutoff);
    setSearchText("");
    setFilterColumn("all");
    setActiveTab("pending"); // Reset tab state in component
    pagination.setCurrentPage(1);
  };
  // --------------------------------------------------------

  // set start and end date for input date
  // const startAndEndDate = useCallback(() => {
  //   const filteredCutoff = handleCutoffChange(selectedCutOff?.id);

  //   setCutOffDate(filteredCutoff); // set state for input date
  // }, [cutOffs, selectedCutOff]);

  // useEffect(() => {
  //   startAndEndDate();
  // }, [selectedCutOff]);

  // Replaced by checkCutoffDate / warnIfNoCutoff (utils/cutoffDateValidation):
  // its "no cutoff" warning was commented out, so it never warned.
  // const dateValidation = async (selectedDate, clearField, dateLabel, key) => {
  //     try {
  //       const res = await axios.get(`${BASE_URL}/cutoff/dateValidation`, {
  //         params: {
  //           date: selectedDate,
  //         },
  //       });
  //       // if (res.data == false) {
  //       //   swal({
  //       //     icon: "error",
  //       //     title: `Invalid ${dateLabel}`,
  //       //     text: `Please Create Cutoff for this Date (${format(
  //       //       selectedDate,
  //       //       "MMM/dd/yyyy"
  //       //     )})`,
  //       //   }).then(() => {
  //       //     clearField({
  //       //       ...loanData,
  //       //       [key]: "",
  //       //     });
  //       //   });
  //       // }
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };

  const handleClaimLoan = async (
    id,
    amount,
    checkNumber,
    remarks,
    transactionNumber,
    currency_id,
    // subject2_name,
    // subject3_name,
    subject3,
    date_issued,
    loan_name,
    currency_name,
    rowData,
  ) => {
    try {
      // if (currency_name !== "PHP" || currency_id !== 1) {
      //   setPaymentData({
      //     id,
      //     amount,
      //     checkNumber,
      //     remarks,
      //     transactionNumber,
      //     currency_id,
      //     // subject2_name,
      //     // subject3_name,
      //     subject3,
      //     date_issued,
      //     loan_name,
      //     currency_name,
      //     rowData,
      //   });
      //   setClaimType("loan");
      //   handleShowModal();
      //   return;
      // }

      await handleClaimLoanPayment({
        id,
        amount,
        checkNumber,
        remarks,
        transactionNumber,
        currency_id,
        // subject2_name,
        // subject3_name,
        subject3,
        date_issued,
        loan_name,
        currency_name,
        rowData,
      });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
        timer: 2000,
      });
    }
  };

  // Mirrors the "Date Process" column's fallback chain so this check
  // reflects the same date shown in the table for this row.
  const getProcessDate = (row) => {
    const dateValue =
      row.process_date ||
      row.bulk_collection?.collection_date ||
      row.loan_mothers?.[0]?.transaction_date ||
      row.receiving_checks?.[0]?.transaction_date;
    return dateValue ? new Date(dateValue) : null;
  };

  const handleCollectButtonClick = async (row) => {
    // --- Validate: process date must not be later than the maturity date ---
    const processDateValue = getProcessDate(row);
    const maturityDateValue = row.date_issued
      ? new Date(row.date_issued)
      : null;

    if (
      processDateValue &&
      maturityDateValue &&
      processDateValue > maturityDateValue
    ) {
      swal({
        title: "Invalid Process Date",
        text: `The process date (${format(processDateValue, "MMM/dd/yyyy")}) cannot be later than the maturity date (${format(maturityDateValue, "MMM/dd/yyyy")}). Please review this record before collecting.`,
        icon: "error",
        button: "OK",
      });
      return;
    }

    const isTransferCash = !!row.sender_account_list_sub3_id;
    const isLiabilitiesClaim =
      !isTransferCash &&
      row.account_list_sub3?.account_list_base_sub?.module_type ===
        "Liabilities Account";

    // down BEFORE the Select Claim Date modal opens.
    if (isTransferCash || isLiabilitiesClaim) {
      const accountIdToCheck = isTransferCash
        ? row.sender_account_list_sub3_id
        : row.account_list_sub3_id;

      try {
        const balanceRes = await axios.get(
          `${BASE_URL}/outstanding/getAccountBalance/${accountIdToCheck}`,
        );

        const round2 = (n) => Math.round(parseFloat(n || 0) * 100) / 100;

        // check_number doubles as the stored sender-currency amount on
        // cross-currency Transfer Cash rows — same fallback claimTransferCash
        // uses when it actually deducts the sender, so the check matches it.
        const amountToCollect = round2(
          isTransferCash &&
            row.check_number &&
            !isNaN(parseFloat(row.check_number))
            ? row.check_number
            : row.amount,
        );
        const accountBalance = round2(balanceRes.data?.balance);

        if (accountBalance < amountToCollect) {
          ///console.log(amountToCollect);
          swal({
            title: "Insufficient Balance",
            text: `The selected account's balance (${accountBalance}) is lower than the amount (${amountToCollect}). This payment cannot be approved.`,
            icon: "error",
            button: true,
          });
          return;
        }
      } catch (err) {
        console.error("Failed to verify account balance:", err);
        swal({
          title: "Something went wrong",
          text: "Unable to verify account balance. Please try again.",
          icon: "error",
          timer: 2000,
        });
        return;
      }
    }

    setPendingCollectRow(row);
    // Default the claim date to today; the user can still change it
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    setSelectedClaimDate(today);
    setClaimDateError("");

    try {
      const res = await axios.get(`${BASE_URL}/cutoff/getCutoffs`);
      const cutoffs = res.data || [];
      const latestPosted = cutoffs.find((c) => c.isPosted === true);
      // const unposted = cutoffs.find((c) => c.isPosted === false);
      // setUnpostedCutoff(unposted || null);
      setUnpostedCutoff(latestPosted || null);
    } catch (err) {
      console.error("Failed to fetch cutoffs:", err);
      setUnpostedCutoff(null);
    }

    setShowDateModal(true);
  };

  const handleDateConfirm = () => {
    if (!selectedClaimDate) {
      swal({
        title: "Date Required",
        text: "Please pick a claim date before proceeding.",
        icon: "warning",
        buttons: false,
        timer: 2000,
      });
      return;
    }
    setShowDateModal(false);
    const row = pendingCollectRow;

    if (row.check_or_online === "Check") {
      if (row.bulk_collection?.id == null) {
        if (row.isFromLoan) {
          const receiveCheck = row.receiving_checks[0];
          handleModalSubject(
            row?.id,
            receiveCheck.currency_id,
            row.bulk_collection?.id,
            row.bulk_collection?.transaction_number,
            row?.date_issued,
            row,
          );
        } else {
          // alert(selectedClaimDate);
          handleDirectClaimReceivingCheck(
            row?.id,
            row?.account_list_sub3_id,
            row?.date_issued,
            row,
            selectedClaimDate,
            row?.transaction_number,
          );
        }
      } else {
        handleModalSubject(
          row?.id,
          row.bulk_collection?.currency_id,
          row.bulk_collection?.id,
          row.bulk_collection?.transaction_number,
          row?.date_issued,
          row,
        );
      }
    } else {
      handleClaim(
        row.id,
        row?.bulk_collection?.id,
        row?.date_issued,
        row,
        selectedClaimDate,
      );
    }
    // }
  };

  const handleClaimLoanPayment = async ({
    id,
    amount,
    checkNumber,
    remarks,
    transactionNumber,
    currency_id,
    // subject2_name,
    // subject3_name,
    subject3,
    date_issued,
    loan_name,
    currency_name,
    rowData,
  }) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("center-swal-text");
    wrapper.innerHTML =
      "Once you claim, you will not be able to recover this check";
    const toPay = await swal({
      title: "Are you sure?",
      content: wrapper,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (toPay) {
      await axios
        .post(BASE_URL + "/loan_outstanding/claimLoan", {
          bulkPaymentId: id,
          amount,
          checkNumber,
          remarks,
          transactionNumber,
          currency_id,
          // subject2_name,
          // subject3_name,
          subject3,
          date_issued,
          loan_name,
          userLoggedID,
          currency_name,
          currencyRate,
          rowData,
        })
        .then((res) => {
          if (res.status === 200) {
            swal({
              title: "Loan Claimed",
              text: "The loan has been claimed",
              icon: "success",
              timer: 2000,
            }).then(() => {
              // const [filteredCutoff] = cutOffs.filter((item) => {
              //   return item.id == selectedCutOff?.id;
              // });
              // fetchCollectionsData(filteredCutoff);
              pagination.refreshData();
              setRefreshKey((prev) => prev + 1);
            });
          } else {
            swal({
              title: "Something went wrong",
              text: "Please contact your support immediately",
              icon: "error",
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 409) {
            swal({
              title: "Oopps!",
              text: "Action is prohibited as the Claim date has already been posted",
              icon: "error",
              button: true,
            });
          } else if (error.response.status === 401) {
            swal({
              icon: "error",
              // title: "Please contact your support",
              title: error.response.data.title,
              text: error.response.data.message,
            }); // test 1
          }
        });
    }
  };

  const handleSubmitForeignRateModal = async () => {
    try {
      if (currencyRate === "") {
        swal({
          title: "Field required.",
          text: "Please fill in the Foreign rate.",
          icon: "error",
          timer: 2000,
        });
        return;
      }

      switch (claimType) {
        case "loan":
          await handleClaimLoanPayment(paymentData);
          break;
        case "No Check Number":
          await handleClaimPayment(paymentData);
          break;
        default:
          break;
      }
      handleCloseModal();
    } catch (error) {
      console.error(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
        timer: 2000,
      });
    }
  };

  // ======= Commented since it revised for centralized useEffect (check at the above) =======
  // useEffect(() => {
  //   console.log("Collect", collectionsData);
  // }, [collectionsData]);

  // const pagination = useServerPagination(
  //   BASE_URL + "/outstanding/getOutstandingCollectionData",
  //   10
  // );

  // const fetchCollectionsData = (cutOff) => {
  //   let startDate = "";
  //   let endDate = "";
  //   if (cutOff) {
  //     startDate = cutOff?.from;
  //     endDate = cutOff?.to;
  //   } else {
  //     startDate = cutOffDate?.from;
  //     endDate = cutOffDate?.to;
  //   }
  //   pagination.updateParams({
  //     dateFrom: cutOff?.from,
  //     dateTo: cutOff?.to,
  //     filterColumn,
  //     searchText,
  //     accountId: selectedAccount.current?.value,
  //   });
  //   setIsLoading(false);
  // axios
  //   .get(BASE_URL + "/outstanding/getOutstandingCollectionData", {
  //     params: {
  //       startDate: cutOff?.from,
  //       endDate: cutOff?.to,
  //       filterColumn,
  //       searchText,
  //       selectedAccount: selectedAccount.current,
  //     },
  //   })
  //   .then((res) => {
  //     const { data, totalClaimed, totalUnclaimed } = res.data;
  //     setWidget((prev) => ({
  //       ...prev,
  //       totalClaimed: totalClaimed,
  //       totalUnclaimed: totalUnclaimed,
  //     }));
  //     setCollectionsData(data);
  //     setIsLoading(false);
  //   })
  //   .catch((err) => {
  //     console.log(err);
  //   });
  // };

  // const fetchCutoff = async () => {
  // try {
  //   const res = await axios.get(BASE_URL + "/outstanding/getCutoffs");
  //   let defaultCutOff = res.data[0];
  //   // get the latest date for default cut off
  //   for (let index = 1; index < res.data.length; index++) {
  //     if (res.data[index].to > defaultCutOff.to) {
  //       defaultCutOff = res.data[index];
  //     }
  //   }
  //   if (selectedCutOff) {
  //     const filteredCutoff = handleCutoffChange(selectedCutOff?.id);
  //     setSelectedCutOff(filteredCutoff);
  //     fetchCollectionsData(filteredCutoff);
  //   } else {
  //     setCutOffs(res.data);
  //     setSelectedCutOff(defaultCutOff);
  //     fetchCollectionsData(defaultCutOff);
  //   }
  // } catch (error) {
  //   console.log(error);
  // }

  //   const boundaries = getMonthBoundaries();
  //   const initialCutoff = initializeCutoff(boundaries);

  //   setSelectedCutOff(initialCutoff);
  //   setCutOffDate(initialCutoff);
  //   fetchCollectionsData(initialCutoff);
  //   fetchAccountListSub3ForSelect();
  // };
  // ================================================================

  const fetchAccountListSub3ForSelect = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/outstanding/getAccountListSub3ForSelect`,
      );
      setAccountListSub3(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleModalSubject = (
    paymentId,
    currencyId,
    bulkId,
    transactionNumber,
    date_issued,
    rowData,
    selectedClaimDate,
  ) => {
    setSelectedRowId(paymentId);
    setCurrencyId(currencyId);
    setSelectedBulkCollectionId(bulkId);
    setTransactionNumber(transactionNumber);
    setSelectedRowIssuedDate(date_issued);
    setIssuedCheckNumber(rowData.check_number);

    console.log("Payment id ", paymentId);

    if (rowData.bulk_collection) {
      setIsFromSalesCollection(true);
      const { currency } = rowData.bulk_collection;
      setIsNotPhp(
        !(
          currency?.currency_name === "PHP" &&
          currency?.id === "11111111-1111-1111-1111-111111111111"
        ),
      );
    } else {
      setIsNotPhp(false);
    }
    setCollectionCheckRowData(rowData);
    setModalSubject(true);
  };

  const handleCloseModalSubject = () => {
    setModalSubject(false);
    setIsFromSalesCollection(false);
    setIsVisibleLiabNote(false);
    setSubject1("");
    setSubject2("");
    setSubject3("");
    setCollectionCheckRowData([]);
    // setShowAddLoanModal(false);
    setIsSubject2Disabled(true);
    setIsSubject3Disabled(true);
  };

  // export
  // const handleExport = () => {
  //   // This function will be called when the export button is clicked
  //   setShowConfirmModal(true);
  // };

  // const exportToCSV = () => {
  //   // Prepare your data for CSV export
  //   const csvData = filteredItems.map((item) => ({
  //     Date: item.date,
  //     "Transaction No": item.transac_no,
  //     Bank: item.bank_name,
  //     Description: item.description,
  //     "Account Name": item.account_name,
  //     Amount: item.amount,
  //     Status: item.status,
  //   }));

  //   return csvData;
  // };
  // para naman sa payment sales collection na WALANG check number
  const handleClaim = async (
    id,
    bulkId,
    date_issued,
    rowData,
    selectedClaimDate,
  ) => {
    try {
      // if (rowData.bulk_collection) {
      //   if (
      //     rowData?.bulk_collection.currency?.currency_name !== "PHP" ||
      //     rowData?.bulk_collection.currency?.id !== 1
      //   ) {
      //     setPaymentData({
      //       id,
      //       bulkId,
      //       date_issued,
      //       rowData,
      //     });
      //     setClaimType("No Check Number");
      //     handleShowModal();
      //     return;
      //   }
      // }

      console.log(rowData);

      handleClaimPayment({
        id,
        bulkId,
        date_issued,
        rowData,
        selectedClaimDate,
      });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
        timer: 2000,
      });
    }
  };

  const handleClaimPayment = async ({
    id,
    bulkId,
    date_issued,
    rowData,
    selectedClaimDate,
  }) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("center-swal-text");
    wrapper.innerHTML =
      "Once you claim, you will not be able to recover this check";
    const toPay = await swal({
      title: "Are you sure?",
      content: wrapper,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    // console.log("rowData1111", rowData);

    if (toPay) {
      // const paymentData = payments.map((payment) => ({
      //   customerId,
      //   account_list_sub3_id: payment.account_list_sub3_id,
      //   amount: payment.amount,
      //   check_number: payment.check_number,
      //   ref_number: payment.ref_number,
      //   date_issued: payment.date_issued,
      //   payment_type: payment.payment_type,
      // }));
      await axios
        .post(BASE_URL + "/outstanding/claim/no-check", {
          id,
          bulkId,
          userLoggedID,
          date_issued,
          rowData,
          selectedClaimDate,
          salesJournal: rowData.bulk_collection
            ? {
                customerId: rowData.bulk_collection.customer_id,
                transactionNumber: rowData.transaction_number,
                processDate: rowData.process_date,
                totalAmount: rowData.amount,
                currencyName: rowData.bulk_collection.currency?.currency_name,
                currencyRate: rowData.bulk_collection.currency?.currency_rate,
                currencyID: rowData.bulk_collection.currency?.id,
              }
            : null,
          advance_payment:
            rowData?.bulk_collection_advance_payments[0]?.amount || 0,
        })
        .then((res) => {
          if (res.status === 200) {
            swal({
              title: "Collections Claimed",
              text: "The collections has been claimed",
              icon: "success",
              timer: 2000,
            }).then(() => {
              // fetchCutoff();
              pagination.refreshData();
              setRefreshKey((prev) => prev + 1);
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 400) {
              swal({
                title: "Bad Request",
                text:
                  error.response.data.message ||
                  "Invalid input or collections not found.",
                icon: "error",
                timer: 2000,
              });
            } else if (error.response.status === 404) {
              swal({
                title: "Collections Not Found",
                text: "The collections you are trying to claim does not exist.",
                icon: "error",
                timer: 2000,
              });
            } else if (error.response.status === 409) {
              swal({
                title: "Oopps!",
                // text: "Action is prohibited as the Issued date has already been posted",
                text: error.response.data.message,
                icon: "error",
                button: true,
              });
            } else if (error.response.status === 401) {
              swal({
                icon: "error",
                // title: "Please contact your support",
                title: error.response.data.title,
                text: error.response.data.message,
                timer: 2000,
              }); // test 1
            } else {
              swal({
                title: "Something went wrong",
                text: "Please contact your support immediately",
                icon: "error",
                timer: 2000,
              });
            }
          } else {
            swal({
              title: "Something went wrong",
              text: "Please contact your support immediately",
              icon: "error",
              timer: 2000,
            });
          }
        });
    }
  };
  // para naman sa payment sales collection na merong check number
  const handleClaimSubject = async (e, type) => {
    e.preventDefault();
    const form = e.currentTarget;

    console.log(`collectionCheckRowData`, collectionCheckRowData);
    if (form.checkValidity() === false) {
      // e.preventDefault();
      e.stopPropagation();
      setValidated(true);
      swal({
        icon: "error",
        title: "Required Fields",
        text: "Please fill in all required fields.",
      });
    } else {
      try {
        // console.log(
        //   // subject1,
        //   // subject3,
        //   selectedRowId,
        //   // selectedBulkCollectionId,
        //   // userLoggedID,
        //   // selectedRowIssuedDate,
        //   // collectionCheckRowData,

        //   "///////////",
        // );

        // Liabilities Account balances are drawn down (deducted), not added
        // to, when used to claim a check — same as handleCollectButtonClick
        // already guards for pre-selected Liabilities/Transfer Cash claims.
        // The selected account must actually have enough to cover the amount
        // being claimed, or this would drive that account negative.
        if (subject1 === "Liabilities Account" && subject3?.value) {
          const round2 = (n) => Math.round(parseFloat(n || 0) * 100) / 100;
          const amountToClaim = round2(collectionCheckRowData.amount);

          const balanceRes = await axios.get(
            `${BASE_URL}/outstanding/getAccountBalance/${subject3.value}`,
          );
          const accountBalance = round2(balanceRes.data?.balance);

          if (accountBalance < amountToClaim) {
            swal({
              title: "Insufficient Balance",
              text: `The selected account's balance (${accountBalance}) is lower than the amount (${amountToClaim}). This payment cannot be approved.`,
              icon: "error",
              button: true,
            });
            return;
          }
        }

        const wrapper = document.createElement("div");
        wrapper.classList.add("center-swal-text");
        wrapper.innerHTML =
          "Once you claim, you will not be able to recover this check";
        const toPay = await swal({
          title: "Are you sure?",
          content: wrapper,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        });

        if (toPay) {
          if (
            collectionCheckRowData.bulk_collection_id == null &&
            collectionCheckRowData.bulk_collection == null
          ) {
            await axios
              .post(BASE_URL + "/outstanding/claimReceivingCheck", {
                subject1,
                subject3: subject3?.value,
                id: selectedRowId,
                userLoggedID,
                date_issued: selectedRowIssuedDate,
                rowData: collectionCheckRowData,
                selectedClaimDate: selectedClaimDate,
                // currencyRate,
              })
              .then((res) => {
                if (res.status === 200) {
                  setIsVisibleLiabNote(false);
                  swal({
                    title: "Collections Claimed",
                    text: "The collections has been claimed",
                    icon: "success",
                    timer: 2000,
                  }).then(() => {
                    handleCloseModalSubject();

                    // fetchCutoff();
                    pagination.refreshData();
                    setRefreshKey((prev) => prev + 1);
                  });
                }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.status === 400) {
                    swal({
                      title: "Bad Request",
                      text:
                        error.response.data.message ||
                        "Invalid input or collections not found.",
                      icon: "error",
                      timer: 2000,
                    });
                  } else if (error.response.status === 401) {
                    swal({
                      icon: "error",
                      // title: "Please contact your support",
                      title: error.response.data.title,
                      text: error.response.data.message,
                    }); // test 1
                  } else if (error.response.status === 404) {
                    swal({
                      title: "Collections Not Found",
                      text: "The collections you are trying to claim does not exist.",
                      icon: "error",
                      timer: 2000,
                    });
                  } else if (error.response.status === 409) {
                    swal({
                      title: "Oopps!",
                      // text: "Action is prohibited as the Issued date has already been posted",
                      text: error.response.data.message,
                      icon: "error",
                      button: true,
                    });
                  } else {
                    swal({
                      title: "Something went wrong",
                      text: "Please contact your support immediately",
                      icon: "error",
                      timer: 2000,
                    });
                  }
                } else {
                  swal({
                    title: "Something went wrong",
                    text: "Please contact your support immediately",
                    icon: "error",
                    timer: 2000,
                  });
                }
              });
          } else {
            await axios
              .post(BASE_URL + "/outstanding/claim/with-check", {
                subject1,
                subject3: subject3?.value,
                id: selectedRowId,
                selectedBulkCollectionId,
                userLoggedID,
                date_issued: selectedRowIssuedDate,
                rowData: collectionCheckRowData,
                selectedClaimDate,
                // prettier-ignore
                salesJournal: {
                  customerId: collectionCheckRowData.bulk_collection.customer_id,
                  totalAmount: collectionCheckRowData.amount,
                  transactionNumber: collectionCheckRowData.transaction_number,
                  // processDate: collectionCheckRowData.process_date,
                  processDate: selectedClaimDate,
                  currencyName: collectionCheckRowData.bulk_collection.currency.currency_name,
                  currencyRate: collectionCheckRowData.bulk_collection.currency.currency_rate
                },
              })
              .then((res) => {
                if (res.status === 200) {
                  swal({
                    title: "Collections Claimed",
                    text: "The collections has been claimed",
                    icon: "success",
                    timer: 2000,
                  }).then(() => {
                    handleCloseModalSubject();

                    // fetchCutoff();
                    pagination.refreshData();
                    setRefreshKey((prev) => prev + 1);
                  });
                }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.status === 400) {
                    swal({
                      title: "Bad Request",
                      text:
                        error.response.data.message ||
                        "Invalid input or collections not found.",
                      icon: "error",
                      timer: 2000,
                    });
                  } else if (error.response.status === 401) {
                    swal({
                      icon: "error",
                      // title: "Please contact your support",
                      title: error.response.data.title,
                      text: error.response.data.message,
                    }); // test 1
                  } else if (error.response.status === 404) {
                    swal({
                      title: "Collections Not Found",
                      text: "The collections you are trying to claim does not exist.",
                      icon: "error",
                      timer: 2000,
                    });
                  } else if (error.response.status === 409) {
                    swal({
                      title: "Oopps!",
                      // text: "Action is prohibited as the Issued date has already been posted",
                      text: error.response.data.message,
                      icon: "error",
                      button: true,
                    });
                  } else {
                    swal({
                      title: "Something went wrong",
                      text: "Please contact your support immediately",
                      icon: "error",
                      timer: 2000,
                    });
                  }
                } else {
                  swal({
                    title: "Something went wrong",
                    text: "Please contact your support immediately",
                    icon: "error",
                    timer: 2000,
                  });
                }
              });
          }
        }
      } catch (error) {
        console.log(error);
        swal({
          title: "Something went wrong",
          text: "Please contact your support immediately",
          icon: "error",
          timer: 2000,
        });
      }
    }
  };

  // Dedicated handler for Cash transfer payments (deferred flow).
  // When "Pay With: Cash" is used in Transfer Money, no balance change happens at
  // submit time. A BulkCollectionPayment (check_or_online = "Cash") is created so
  // the record shows in the Pending Tab. At Collect & Confirm the sender is finally
  // deducted, the receiver is credited, and txn history entries are written.
  const handleDirectClaimTransferCash = async (
    id,
    subject3Id,
    date_issued,
    rowData,
    selectedClaimDate,
    transactionNumber,
  ) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("center-swal-text");
    wrapper.innerHTML =
      "Once you confirm, the balance will be transferred and cannot be undone";
    const toPay = await swal({
      title: "Are you sure?",
      content: wrapper,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!toPay) return;

    try {
      const res = await axios.post(
        BASE_URL + "/outstanding/claimTransferCash",
        {
          id,
          userLoggedID,
          date_issued,
          selectedClaimDate,
        },
      );

      if (res.status === 200) {
        swal({
          title: "Cash Transfer Claimed",
          text: "The cash transfer has been successfully confirmed",
          icon: "success",
          timer: 2000,
        }).then(() => {
          pagination.refreshData();
          setRefreshKey((prev) => prev + 1);
        });
      }
    } catch (error) {
      if (error.response?.status === 409) {
        const msg = error.response?.data?.message || "";
        swal({
          title: "Oopps!",
          text: msg.includes("already been claimed")
            ? "This transfer has already been claimed."
            : "Action is prohibited as the Claim date falls within a posted cutoff period.",
          icon: "error",
          button: true,
        });
      } else if (error.response?.status === 400) {
        swal({
          title: "Insufficient Balance",
          text:
            error.response?.data?.message ||
            "The sender account does not have enough balance.",
          icon: "error",
          button: true,
        });
      } else if (error.response.status === 401) {
        swal({
          icon: "error",
          // title: "Please contact your support",
          title: error.response.data.title,
          text: error.response.data.message,
        }); // test 1
      } else if (error.response?.status === 422) {
        swal({
          title: "Cannot Claim Transfer",
          text:
            error.response?.data?.message ||
            "Sender account not found. Please contact support.",
          icon: "error",
          button: true,
        });
      } else {
        swal({
          title: "Something went wrong",
          text: "Please contact your support immediately",
          icon: "error",
          timer: 2000,
        });
      }
    }
  };

  // For transfer-originated checks (no bulk_collection): the receiver balance was
  // already incremented at transfer time, so we only need to mark the payment as
  // Claimed and confirm the bank record — no balance changes, no loan journals.
  // Uses the dedicated /outstanding/claimTransferCheck route instead of
  // claimReceivingCheck (which would double/triple-count the balance).
  const handleDirectClaimReceivingCheck = async (
    id,
    subject3Id,
    date_issued,
    rowData,
    selectedClaimDate,
    transactionNumber,
  ) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("center-swal-text");
    wrapper.innerHTML =
      "Once you claim, you will not be able to recover this check";
    const toPay = await swal({
      title: `Are you sure?`,
      content: wrapper,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!toPay) return;

    try {
      const res = await axios.post(
        BASE_URL + "/outstanding/claimTransferCheck",
        {
          id,
          userLoggedID,
          date_issued,
          selectedClaimDate,
        },
      );

      if (res.status === 200) {
        swal({
          title: "Check Claimed",
          text: "The transfer check has been claimed",
          icon: "success",
          timer: 2000,
        }).then(() => {
          pagination.refreshData();
          setRefreshKey((prev) => prev + 1);
        });
      }
    } catch (error) {
      const title = "Cannot Claim Check";
      if (error.response?.status === 409) {
        const msg = error.response?.data?.message || "";
        swal({
          title: title,
          text: msg.includes("already been claimed")
            ? "This check has already been claimed."
            : "Action is prohibited as the Claim date has already been posted",
          icon: "error",
          button: true,
        });
      } else if (error.response?.status === 422) {
        swal({
          title: title,
          text:
            error.response?.data?.message ||
            "Sender account not found. Please contact support.",
          icon: "error",
          button: true,
        });
      } else if (error.response?.status === 404) {
        swal({
          title: title,
          text: error.response?.data?.message || "Validation Failed",
          icon: "error",
          button: true,
        });
      } else if (error.response.status === 401) {
        swal({
          icon: "error",
          // title: "Please contact your support",
          title: error.response.data.title,
          text: error.response.data.message,
        }); // test 1
      } else {
        swal({
          title: "Something went wrong",
          text: "Please contact your support immediately",
          icon: "error",
          timer: 2000,
        });
      }
    }
  };

  // Dedicated handler for transfer-originated Online (bank WITHOUT check) payments.
  // These records have bulk_collection_id = NULL, so the generic handleClaim → /claimCollections
  // route silently fails (required JOIN on BulkCollection returns null).
  // At claim time the sender is finally deducted and the receiver is credited server-side.
  const handleDirectClaimTransferNoCheck = async (
    id,
    subject3Id,
    date_issued,
    rowData,
    selectedClaimDate,
    transactionNumber,
  ) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("center-swal-text");
    wrapper.innerHTML =
      "Once you confirm, you will not be able to recover this transfer";
    const toPay = await swal({
      title: "Are you sure?",
      content: wrapper,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!toPay) return;

    try {
      const res = await axios.post(
        BASE_URL + "/outstanding/claimTransferNoCheck",
        {
          id,
          userLoggedID,
          date_issued,
          selectedClaimDate,
        },
      );

      if (res.status === 200) {
        swal({
          title: "Transfer Claimed",
          text: "The online transfer has been successfully claimed",
          icon: "success",
          timer: 2000,
        }).then(() => {
          pagination.refreshData();
          setRefreshKey((prev) => prev + 1);
        });
      }
    } catch (error) {
      if (error.response?.status === 409) {
        const msg = error.response?.data?.message || "";
        swal({
          title: "Oopps!",
          text: msg.includes("already been claimed")
            ? "This transfer has already been claimed."
            : "Action is prohibited as the date falls within a posted cutoff period.",
          icon: "error",
          button: true,
        });
      } else if (error.response.status === 401) {
        swal({
          icon: "error",
          // title: "Please contact your support",
          title: error.response.data.title,
          text: error.response.data.message,
        }); // test 1
      } else if (error.response?.status === 422) {
        swal({
          title: "Cannot Claim Transfer",
          text:
            error.response?.data?.message ||
            "Sender account not found. Please contact support.",
          icon: "error",
          button: true,
        });
      } else {
        swal({
          title: "Something went wrong",
          text: "Please contact your support immediately",
          icon: "error",
          timer: 2000,
        });
      }
    }
  };

  const handleDeleteCollection = async (
    collectionId,
    collectionDateIssued,
    process_date,
  ) => {
    swal({
      title: "Confirm Deletion",
      text: "Are you sure you want to delete?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await axios.delete(
            `${BASE_URL}/outstanding/deleteCollection/${collectionId}/${collectionDateIssued}/${process_date}`,
            { data: { userLoggedID } },
          );

          if (response.status === 200) {
            swal({
              title: "Collection Deleted Successfully!",
              text: "The collection has been successfully deleted.",
              icon: "success",
              button: "OK",
            }).then(() => {
              pagination.refreshData();
            });
          } else if (response.status === 202) {
            const { dateIssued, CutoffName } = response.data;
            swal({
              title: "Delete Prohibited!",
              text: `Collection cannot be deleted as its date issued (${dateIssued}) falls within the posted cutoff period named "${CutoffName}".`,
              icon: "warning",
              button: "OK",
            });
          } else {
            swal({
              icon: "error",
              title: "Something went wrong",
              text: "Please contact our support team for assistance.",
            });
          }
        } catch (error) {
          if (error.response?.status === 422) {
            swal({
              title: "Cannot Delete Payment",
              text: error.response.data.message,
              icon: "error",
              button: "OK",
            });
          } else if (error.response.status === 401) {
            swal({
              icon: "error",
              // title: "Please contact your support",
              title: error.response.data.title,
              text: error.response.data.message,
            }); // test 1
          } else {
            swal({
              icon: "error",
              title: "Error",
              text: "An error occurred while deleting the collection.",
            });
          }
        }
      }
    });
  };

  const columns = [
    {
      name: "Transaction No.",
      sortField: "transaction_number",
      selector: (row) =>
        row.transaction_number
          ? row.transaction_number
          : row.bulk_collection
            ? row.bulk_collection?.transaction_number
            : row.loan_mothers[0]
              ? row.loan_mothers[0]?.transaction_number
              : "---", // Accessing the first loan_mother's transaction_number
    },
    {
      name: "Date Process",
      sortField: "process_date",
      selector: (row) =>
        (row.process_date &&
          format(new Date(row.process_date), "MMM/dd/yyyy")) ||
        (row.bulk_collection?.collection_date &&
          format(
            new Date(row.bulk_collection.collection_date),
            "MMM/dd/yyyy",
          )) ||
        (row.loan_mothers?.[0]?.transaction_date &&
          format(
            new Date(row.loan_mothers[0].transaction_date),
            "MMM/dd/yyyy",
          )) ||
        (row.receiving_checks?.[0]?.transaction_date &&
          format(
            new Date(row.receiving_checks[0].transaction_date),
            "MMM/dd/yyyy",
          )),
    },
    {
      name: "Maturity Date",
      sortField: "date_issued",
      selector: (row) =>
        row.date_issued ? format(row.date_issued, "MMM/dd/yyyy") : "---",
    },
    {
      name: "Issued To",
      sortField: "issued_to",
      selector: (row) =>
        row.account_list_sub3_id
          ? ` ${row.account_list_sub3?.account_name} (${row.account_list_sub3?.account_list_base_sub?.subject_name})`
          : "--",
    },
    {
      name: "Payment Method",
      sortField: "payment_type",
      selector: (row) => row.payment_type,
    },
    {
      name: "Check Number",
      sortField: "check_number",
      selector: (row) => row.check_number || "---",
    },
    {
      name: "Reference Number",
      sortField: "ref_number",
      selector: (row) => row.ref_number || "---",
    },
    {
      name: "Amount",
      sortField: "amount",
      selector: (row) => {
        // currency_name is stored directly on the payment row (populated since the fix).
        // For older rows that predate the fix, fall back through related records.
        const currencyName =
          row.currency_name ||
          row.bulk_collection?.currency?.currency_name ||
          row.receiving_checks?.[0]?.currency?.currency_name ||
          "";
        return `${currencySymbol[currencyName] || currencyName} ${formatToTwoDecimal(row.amount)}`.trim();
      },
    },
    {
      name: "Status",
      cell: (row) => {
        const currentDate = new Date();
        const dateIssued = new Date(row.date_issued);

        // Compare current date with the date_issued
        const isDateValid = currentDate >= dateIssued;

        // No active (non-deleted) cutoff covers this maturity date
        const hasNoCutoff = !row.hasCutoff;

        const isDisabled =
          row.status !== "Approved" || !isDateValid || hasNoCutoff;

        return (
          <div className="d-flex">
            {row.status === "Claimed" ? (
              <div style={{ color: "green", fontWeight: "bold" }}>
                Collected
              </div>
            ) : (
              <>
                <button
                  onClick={() => handleCollectButtonClick(row)}
                  className={`btn btn-primary ${isDisabled ? "disabled" : ""}`}
                  disabled={isDisabled}
                  title={
                    !isDateValid
                      ? `Cannot collect before maturity date (${format(new Date(row.date_issued), "MMM/dd/yyyy")})`
                      : hasNoCutoff
                        ? `No active cutoff covers this date (${format(new Date(row.date_issued), "MMM/dd/yyyy")})`
                        : undefined
                  }
                  style={{
                    cursor: isDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  {row.account_list_sub3_id === null
                    ? "Select Account"
                    : "Collect"}
                </button>
              </>
            )}
          </div>
        );
      },
    },
  ];
  if (authrztn.includes("OutstandingCheck-Delete")) {
    columns.push({
      name: "Action",
      selector: (row) => (
        <>
          <i
            className="fas fa-trash"
            style={{
              cursor: "pointer",
              color: "red",
              fontSize: "1.5rem",
              opacity: row?.receiving_checks?.length != 0 ? 1 : 0.5,
            }}
            onClick={() => {
              // if (row?.receiving_checks?.length != 0) {
              handleDeleteCollection(row.id, row.date_issued, row.process_date);
              //   return;
              // }

              // const wrapper = document.createElement("div");
              // wrapper.classList.add("center-swal-text");
              // wrapper.innerHTML =
              //   "To delete this transaction, please delete it first from Local or Overseas Collection.";
              // swal({
              //   icon: "warning",
              //   title: "Warning",
              //   content: wrapper,
              //   button: "OK",
              // });
              // return;
            }}
          ></i>
        </>
      ),
    });
  }

  const conditionalRowStyles = [
    {
      when: (row) => row.status === "Not Deposit",
      style: {
        borderLeft: "4px solid blue",
      },
    },
  ];

  const handleSubject1Change = (event) => {
    const selectedSubject1 = event.target.value;
    let account_selected = "";

    if (selectedSubject1 === "Account-List") {
      setIsVisibleLiabNote(false);
      account_selected = "Account-List";
    } else if (selectedSubject1 === "Asset Account") {
      setIsVisibleLiabNote(false);
      account_selected = "Asset Account";
    } else if (selectedSubject1 === "Liabilities Account") {
      setIsVisibleLiabNote(true);
      account_selected = "Liabilities Account";
    } else if (selectedSubject1 === "Owner's Equity Account") {
      setIsVisibleLiabNote(false);
      account_selected = "Owner's Equity Account";
    }

    try {
      axios
        .get(`${BASE_URL}/outstanding/getSubject2`, {
          params: {
            account_selected: account_selected,
          },
        })
        .then((res) => {
          setSubject1(selectedSubject1);
          setSubject2DataList(res.data);
          setIsSubject2Disabled(false);
        });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  // Update Subject 3 based on Subject 2 selection
  const handleSubject2Change = (selectedOption) => {
    const selectedSubject2 = selectedOption;
    console.log("Curr ID", currencySelectedId);
    console.log("Selected Subjj", selectedSubject2);
    try {
      axios
        .get(`${BASE_URL}/outstanding/getSubject3ChainDropdown`, {
          params: {
            subjectId: selectedSubject2?.value,
            currencyId: currencySelectedId,
          },
        })
        .then((res) => {
          setSubject3DataList(res.data);
          setSubject2(selectedSubject2);
          setIsSubject3Disabled(false);
        });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  const handleSubject3Change = (selectedOption) => {
    const selectedSubject3 = selectedOption;
    setSubject3(selectedSubject3);
  };

  // search
  // const filteredItems = localData.filter((item) => {
  //   if (!searchText) return true;

  //   const searchLower = searchText.toLowerCase();
  //   // const contactPerson = `${item.fname} ${item.lname}`.toLowerCase(); // Concatenate and convert to lower case

  //   switch (filterColumn) {
  //     case "date":
  //       return item.date.toLowerCase().includes(searchLower);
  //     case "transac_no":
  //       return item.transac_no.toLowerCase().includes(searchLower);
  //     case "bank_name":
  //       return item.bank_name.toLowerCase().includes(searchLower);
  //     case "description":
  //       return item.description.toLowerCase().includes(searchLower);
  //     case "account_name":
  //       return item.account_name.toLowerCase().includes(searchLower);
  //     case "amount":
  //       return item.amount.toLowerCase().includes(searchLower);
  //     case "status":
  //       return item.status.toLowerCase().includes(searchLower);
  //     default:
  //       return (
  //         item.date.toLowerCase().includes(searchLower) ||
  //         item.transac_no.toLowerCase().includes(searchLower) ||
  //         item.bank_name.toLowerCase().includes(searchLower) ||
  //         item.description.toLowerCase().includes(searchLower) ||
  //         item.account_name.toLowerCase().includes(searchLower) ||
  //         item.amount.toLowerCase().includes(searchLower) ||
  //         item.status.toLowerCase().includes(searchLower)
  //       );
  //   }
  // });

  // For Receiving Check
  const fetchSubject2Data = (value) => {
    try {
      axios
        .get(BASE_URL + "/accountListSub/getSubject", {
          params: {
            account_selected: value,
          },
        })
        .then((res) => {
          // console.log(res.data);
          setSubject2LoanDataList(res.data);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchSubject3Data = (value) => {
    try {
      axios
        .get(BASE_URL + "/accountListSub/getSubject3", {
          params: { subjectId: value },
        })
        .then((res) => {
          setSubject3LoanDataList(res.data);
          console.log(res.data);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCurrencyList = () => {
    try {
      axios.get(BASE_URL + "/currency/fetchCurrency").then((res) => {
        setCurrencyList(res.data);
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleLoanAmount = (e) => {
    let value = e.target.value;

    if (value == ".") {
      setLoanData((prev) => ({
        ...prev,
        amount: prev.amount + ".",
      }));
    }

    let inputValue = value.replace(/[^0-9.]/g, "");

    let [integerPart, decimalPart] = inputValue.split(".");

    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    const cleanedValue = formattedValue.replace(/^0+,|^0+/, ""); // Remove leading zeros and comma

    setLoanData({
      ...loanData,
      amount: cleanedValue,
    });
  };

  // from modUle  creating loan
  const handleSubmitReceivingCheck = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      // e.preventDefault();
      e.stopPropagation();
      setValidated(true);
      swal({
        icon: "error",
        title: "Required Fields",
        text: "Please Fill in all required fields.",
        button: "OK",
      });
    } else {
      // Transaction Date must not fall in a posted cutoff
      if (transactionDatePostedCutoff) {
        swal({
          icon: "error",
          title: "Transaction Date Conflict",
          text: "The transaction date you selected is already posted in the cutoff period!",
          button: "OK",
        });
        return;
      }

      // Issued Date must be the same as or later than the Transaction Date
      if (loanData.transactionDate && loanData.issuedDate) {
        const transactionDay = new Date(loanData.transactionDate);
        const issuedDay = new Date(loanData.issuedDate);
        transactionDay.setHours(0, 0, 0, 0);
        issuedDay.setHours(0, 0, 0, 0);
        if (issuedDay < transactionDay) {
          swal({
            icon: "error",
            title: "Invalid Issued Date",
            text: `Issued date cannot be earlier than the transaction date (${format(transactionDay, DATE_DISPLAY_FORMAT)}).`,
            button: "OK",
          });
          return;
        }
      }

      if (!(await validateCheckNumbers(loanData.checkNumber))) return;

      try {
        const confirmation = await swal({
          icon: "warning",
          title: "Are you sure?",
          text: "Once you submit, you will not be able to undo this action.",
          buttons: true,
        });

        // Get the currency rate
        const { currency_rate: currencyRate, currency_name: currencyName } =
          currencyList.find((c) => c.id === loanData.currency_id);

        const formatLoanData = {
          ...loanData,
          subject2: loanData.subject2?.value,
          subject3: loanData.subject3?.value,
          userLoggedID,
          amount: parseFloat(loanData.amount.replace(/,/g, "")),
          currency_rate: currencyRate,
          currencyName,
        };

        if (confirmation) {
          try {
            const res = await axios.post(
              `${BASE_URL}/outstanding/addReceivingCheck`,
              formatLoanData,
            );
            if (res.status === 201) {
              swal({
                icon: "success",
                title: "Receving Check Successful",
                text: "Receiving Check has been added.",
                timer: 2000,
              }).then(() => {
                // const [filteredCutoff] = cutOffs.filter((item) => {
                //   return item.id == selectedCutOff?.id;
                // });
                // handleCloseReceivingCheckModal();
                // fetchCollectionsData(filteredCutoff);
                // fetchCutoff();
                handleCloseReceivingCheckModal();
                pagination.refreshData();
              });
            }
          } catch (error) {
            console.error(error);
            if (error.response.status === 401) {
              swal({
                icon: "error",
                // title: "Please contact your support",
                title: error.response.data.title,
                text: error.response.data.message,
              }); // test 1
            } else {
              swal({
                icon: "error",
                title: "Something Went Wrong.",
                text: "Please Contact your support immediately.",
                button: "OK",
              });
            }
          }
        }
      } catch (error) {
        console.error(error);
        swal({
          icon: "error",
          title: "Something Went Wrong.",
          text: "Please Contact your support immediately.",
          button: "OK",
        });
      }
      setValidated(false);
    }
  };

  // const clearFilter = () => {
  //   setSearchText("");
  //   setFilterColumn("");
  // };

  // Export function for PDF
  const exportToPdf = () => {
    swal({
      icon: "warning",
      title: "Export to PDF?",
      text: "Do you want to export this data as a PDF file?",
      dangerMode: true,
      buttons: true,
    }).then((confirm) => {
      if (confirm) setPrintToPdf(true);
    });
  };

  // Export function for CSV
  const exportToCsv = () => {
    swal({
      icon: "warning",
      title: "Export to CSV?",
      text: "Do you want to export this data as a CSV file?",
      dangerMode: true,
      buttons: true,
    }).then((confirm) => {
      if (confirm) csvLinkRef.current.link.click();
    });
  };

  // Props for Export PDF/CSV
  // const cutoffName = handleCutoffChange(selectedCutOff?.id)?.name;
  const cutoffName = selectedCutOff?.name;
  const props = {
    // accountName: selectedAccount.current?.label ?? "All Account",
    // accountId: selectedAccount.current?.value,
    accountName: selectedAccount?.label ?? "All Account",
    accountId: selectedAccount?.value,
    cutoffName: cutoffName ?? "All",
    dateFrom: cutOffDate?.from,
    dateTo: cutOffDate?.to,
    searchText,
    filterColumn,
  };

  // Account Options for dropdown select
  const accountOptions = accountListSub3.map((item) => ({
    value: item.id,
    label: `${item.account_list_base_sub.subject_name} - ${item.account_name}`,
  }));

  // Subject 2 Options for dropdown select
  const subject2Options = subject2DataList.map((item) => ({
    value: item.id,
    label: item.subject_name,
    subject_type: item.subject_type,
  }));

  // Subject 3 Options for dropdown select
  const subject3Options = subject3DataList.map((item) => ({
    value: item.id,
    label: item.account_name,
  }));

  // Receiving Check Modal Subject 2 Options for dropdown select
  const subject2LoanOptions = subject2LoanDataList.map((item) => ({
    value: item.id,
    label: item.subject_name,
  }));

  // Receiving Check Modal Subject 3 Options for dropdown select
  const subject3LoanOptions = subject3LoanDataList
    .filter((option) => option.currency_id === loanData.currency_id)
    .map((item) => ({
      value: item.id,
      label: item.account_name,
    }));

  // ======= Commented since it revised for centralized useEffect (check at the above) =======
  //   useEffect(() => {
  //   const { data, totalClaimed, totalUnclaimed } = pagination.data;
  //   setWidget((prev) => ({
  //     ...prev,
  //     totalClaimed: totalClaimed,
  //     totalUnclaimed: totalUnclaimed,
  //   }));
  //   setCollectionsData(data);
  // }, [pagination.data]);

  // useEffect(() => {
  //   setSearchText("");
  //   fetchCutoff();
  // }, [filterColumn]);

  // useEffect(() => {
  //   fetchAccountListSub3ForSelect();
  //   fetchCurrencyList();
  //   fetchSubject2Data("Liabilities Account");
  // }, []);

  // useEffect(() => {
  //   fetchCutoff();
  // }, [searchText]);

  // useEffect(() => {
  //   if (selectedAccount.current && filterColumn == "issued_to") {
  //     setFilterColumn("all");
  //   }
  // }, [selectedAccount.current]);

  // const handleDateRangeChange = (startDate, endDate) => {
  //   const cutoff = {
  //     id: "custom",
  //     from: startDate,
  //     to: endDate,
  //   };
  //   setSelectedCutOff(cutoff);
  //   setCutOffDate(cutoff);
  //   setSearchText("");
  //   pagination.setCurrentPage(1);
  //   selectedAccount.current = "";
  //   fetchCollectionsData(cutoff);
  // };
  // ===========================================================================

  // Calculate tab counts using useMemo to prevent unnecessary recalculations
  const pendingCount = useMemo(
    () => collectionsData?.filter((d) => d.status === "Approved").length || 0,
    [collectionsData],
  );

  const collectedCount = useMemo(
    () => collectionsData?.filter((d) => d.status === "Claimed").length || 0,
    [collectionsData],
  );

  // Old Tab Filter
  // Filter data based on active tab
  // const [activeTab, setActiveTab] = useState("pending");

  // const tabFilteredData = useMemo(() => {
  //   return collectionsData?.filter((data) =>
  //     activeTab === "pending"
  //       ? data.status === "Approved"
  //       : data.status === "Claimed"
  //   );
  // }, [collectionsData, activeTab]);
  // =============================================

  // --------- New Tab Filter ---------
  const tabFilteredData = useMemo(
    () =>
      collectionsData?.filter((data) =>
        activeTab === "pending"
          ? data.status === "Approved"
          : data.status === "Claimed",
      ),
    [collectionsData, activeTab],
  );
  // =============================================

  const minClaimDate = useMemo(() => {
    let minDate = null;

    if (pendingCollectRow?.date_issued) {
      minDate = new Date(pendingCollectRow.date_issued);
      minDate.setHours(0, 0, 0, 0);
    }

    if (unpostedCutoff?.to) {
      const [y, m, d] = unpostedCutoff.to.split("T")[0].split("-").map(Number);
      const postedEndDate = new Date(y, m - 1, d);

      const earliestOpenDate = new Date(postedEndDate);
      earliestOpenDate.setDate(earliestOpenDate.getDate() + 1);
      earliestOpenDate.setHours(0, 0, 0, 0);

      if (!minDate || earliestOpenDate > minDate) {
        minDate = earliestOpenDate;
      }
    }

    return minDate;
  }, [pendingCollectRow?.date_issued, unpostedCutoff]);

  // Claim Date modal: typed input must follow MM/dd/yy (e.g. 10/10/26).
  // Slashes are added automatically; anything that is not a valid prefix of
  // that format (letters, extra digits, other date formats) is rejected and
  // the input keeps its previous text.
  const handleClaimDateRaw = (e) => {
    const raw = e?.target?.value;
    if (typeof raw !== "string") return;

    const next = raw
      .replace(/^(\d{2})(\d)/, "$1/$2")
      .replace(/^(\d{2}\/\d{2})(\d)/, "$1/$2");

    if (!/^(\d{0,2}|\d{2}\/\d{0,2}|\d{2}\/\d{2}\/\d{0,2})$/.test(next)) {
      e.preventDefault();
      return;
    }
    e.target.value = next;

    // A complete MM/dd/yy that falls before minClaimDate is silently ignored by
    // react-datepicker (minDate makes that day disabled): onChange never fires,
    // the previous date stays selected and the text snaps back on blur. Flag it
    // here and drop the stale selection so it can't be submitted by mistake.
    if (!/^\d{2}\/\d{2}\/\d{2}$/.test(next)) {
      setClaimDateError(""); // still typing
      return;
    }
    const typed = parseDateFns(next, "MM/dd/yy", new Date());
    if (isValidDateFns(typed) && minClaimDate) {
      typed.setHours(0, 0, 0, 0);
      if (typed < minClaimDate) {
        setSelectedClaimDate("");
        setClaimDateError(
          `Claim date cannot be earlier than ${format(minClaimDate, "MM/dd/yy")}.`,
        );
        return;
      }
    }
    setClaimDateError("");
  };

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      {isLoading ? (
        <div className="loading-container">
          <ThreeDot
            variant="brick-stack"
            color="#6290FE"
            size="large"
            text="Loading Data..."
            // textColor=""
          />
        </div>
      ) : authrztn.includes("OutstandingCheck-View") ? (
        <>
          <div className="w-100 p-2 d-flex flex-row justify-content-between">
            <div className="d-flex flex-column title-custom">
              <span className="fs-3 text-uppercase">
                Outstanding Receivable
              </span>
            </div>

            <div className="d-flex flex-row">
              {/* {authrztn.includes("OutstandingCheck-Add") && (
                <Button
                  variant="outline-success"
                  onClick={() => {
                    setShowAddLoanModal(true);
                  }}
                >
                  <i className="fa-solid fa-plus me-1"></i> Add Loan
                </Button>
              )} */}
              <CollectionCsv
                {...props}
                csvLinkRef={csvLinkRef}
                refreshKey={refreshKey}
              />
              <div className="btn-group">
                <button
                  type="button"
                  className="btn btn-success dropdown-toggle me-2"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Export
                </button>
                <ul className="dropdown-menu">
                  <li
                    className="dropdown-item border-bottom"
                    style={{ cursor: "pointer" }}
                    onClick={() => exportToPdf()}
                  >
                    PDF
                  </li>
                  <li
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => exportToCsv()}
                  >
                    CSV
                  </li>
                </ul>
              </div>
              {authrztn.includes("OutstandingCheck-Add") && (
                <Button
                  className="btn btn-primary d-flex flex-row align-items-center title-button"
                  onClick={() => {
                    // Transaction Date defaults to today
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    setLoanTransactionDate(today);
                    fetchPostedCutoffs();
                    setShowReceivingCheckModal(true);
                  }}
                >
                  <i className="bx bx-plus fs-5"></i> Receiving Check
                </Button>
              )}
            </div>
          </div>
          <div className="container-fluid mt-4 p-0">
            <div
              className="container"
              style={{ paddingRight: "150px", paddingLeft: "150px" }}
            >
              <div className="row mx-auto">
                <div className="col-sm w-100 p-3 payable-card">
                  <div className="w-100 border p-3 shadow-sm rounded h-100">
                    <div className="d-flex flex-row align-items-center payable-icon">
                      <i className="bx bxs-discount fs-3 h-100"></i>
                      <h3>Total Claimed</h3>
                    </div>
                    <div className="mt-2 d-flex flex-column payable-card-desc">
                      <p
                        style={{
                          color: "var(--widget-number-color-orange",
                          fontSize: "2.5rem",
                          cursor: "default",
                        }}
                        title={formatToTwoDecimal(widget.totalClaimed)}
                      >
                        {formatToTwoDecimal(widget.totalClaimed)}
                        {/* {widget.totalClaimed
                          ? compactNumberFormat(widget.totalClaimed)
                          : "0.00"} */}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm w-100 p-3 payable-card">
                  <div className="w-100 border p-3 shadow-sm rounded h-100">
                    <div className="d-flex flex-row align-items-center payable-icon">
                      <i className="bx bx-money-withdraw fs-3 h-100"></i>
                      <h3>Total Unclaimed</h3>
                    </div>
                    <div className="mt-2 d-flex flex-column payable-card-desc">
                      <p
                        style={{
                          color: "var(--widget-number-color)",
                          fontSize: "2.5rem",
                          cursor: "default",
                        }}
                        title={formatToTwoDecimal(widget.totalUnclaimed)}
                      >
                        {formatToTwoDecimal(widget.totalUnclaimed)}
                        {/* {widget.totalUnclaimed
                          ? compactNumberFormat(widget.totalUnclaimed)
                          : "0.00"} */}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-100 row mx-0 mt-3 align-items-end">
            <div className="col-sm mb-2">
              <label htmlFor="">Account</label>
              {/* <select
                value={selectedAccount.current}
                onChange={handleSelectAccount}
                className="form-select"
                onMouseDown={(e) => {
                  if (accountListSub3.length === 0) {
                    e.preventDefault();
                    swal({
                      icon: "warning",
                      title: "No Account Found",
                      text: "No account found. Please add an account first",
                    });
                    return;
                  }
                }}
              >
                <option value="">All Account</option>
                {accountListSub3?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.account_list_base_sub.subject_name} -{" "}
                    {item.account_name}
                  </option>
                ))}
              </select> */}
              <Select
                options={accountOptions}
                // value={selectedAccount.current}
                value={selectedAccount}
                onChange={handleSelectAccount}
                onMenuOpen={() => {
                  if (accountListSub3.length === 0) {
                    swal({
                      icon: "warning",
                      title: "No Account Found",
                      text: "No account found. Please add an account first",
                    });
                    return;
                  }
                }}
                menuIsOpen={accountListSub3.length === 0 ? false : undefined}
                placeholder={`All Account`}
                // styles={themedSelectStyles(selectedAccount.current)}
                styles={themedSelectStyles(selectedAccount)}
                isSearchable
                isClearable
              />
            </div>
            <div className="col-sm mb-2">
              <DateRangePicker
                startDate={cutOffDate?.from ? new Date(cutOffDate.from) : null}
                endDate={cutOffDate?.to ? new Date(cutOffDate.to) : null}
                onDateRangeChange={handleDateRangeChange}
                label="Date Range"
              />
              {/* <label htmlFor="cutoff">Cutoff</label>
              <select
                value={selectedCutOff?.id}
                onChange={handleSelect}
                className="form-select"
                id="cutoff"
                aria-label="Default select example"
                onMouseDown={(e) => {
                  if (cutOffs.length === 0) {
                    e.preventDefault();
                    swal({
                      icon: "warning",
                      title: "No Cutoff Found",
                      text: "No cutoff records found. Please create a cutoff first in Monthly Cutoff Module.",
                    });
                    return;
                  }
                }}
              >
                <option value="All Cutoff">All</option>
                {cutOffs.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select> */}
            </div>
            {/* <div className="col-sm mb-2">
              <label htmlFor="cutoff-start-date">From</label>
              <input
                type="date"
                value={cutOffDate?.from || ""}
                readOnly
                name="cutoff-start-date"
                id="cutoff-start-date"
                className="form-control"
              />
              <DatePicker
                selected={cutOffDate?.from}
                dateFormat="MMM/dd/yyyy"
                className="form-control"
                readOnly
              />
            </div>
            <div className="col-sm mb-2">
              <label htmlFor="cutoff-end-date">To</label>
              <input
                type="date"
                value={cutOffDate?.to || ""}
                readOnly
                name="cutoff-end-date"
                id="cutoff-end-date"
                className="form-control"
              />
              <DatePicker
                selected={cutOffDate?.to}
                dateFormat="MMM/dd/yyyy"
                className="form-control"
                readOnly
              />
            </div> */}
            {/* <div className="col-sm mb-2 d-flex flex-row align-items-end filter-btn-container"> */}
            {/* <button className="btn">Apply Filter</button>
              <button className="btn btn-secondary" onClick={clearFilter}>
                Clear Filter
              </button> */}
            {/* </div>
          </div> */}
            {/* <div className="w-100 d-flex flex-row justify-content-between">
            <div className="w-100"></div>
            <div className="d-flex justify-content-end align-items-center my-3">
              <button
                className="btn btn-outline-success me-2 fs-6"
                // onClick={handleExport}
              >
                <i className="fa-solid fa-download me-1"></i> Export
              </button>
              <button className="btn btn-outline-danger fs-6">
                <i className="fa-solid fa-upload me-1"></i> Import
              </button>
            </div>
          </div> */}
            {/* ------ NEW CLREAR FILTER BUTTON ------ */}
            <div className="col-sm mb-2 d-flex flex-row filter-btn-container">
              <button
                className="btn btn-primary w-100"
                onClick={handleClearFilters}
              >
                <i className="bx bx-reset me-1"></i> Clear All Filters
              </button>
            </div>
          </div>

          <div className="w-100 mt-2 container-fluid">
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchText}
                // onChange={(e) => setSearchText(e.target.value)}
                onChange={(e) => {
                  setSearchText(e.target.value);
                  FilterStore.OCsaveSearch(e.target.value);
                }}
              />
              <button
                type="button"
                className="btn btn-outline-secondary dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-sliders"></i>
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "all" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("all")}
                  >
                    All
                  </button>
                </li>
                {/* <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "account" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("account")}
                  >
                    Account
                  </button>
                </li> */}
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "transaction_number" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("transaction_number")}
                  >
                    Transaction No.
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "transaction_date" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("transaction_date")}
                  >
                    Transaction Date
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "issued_to" ? "active" : ""
                    }`}
                    onClick={() => {
                      setFilterColumn("issued_to");
                      // selectedAccount.current = "";
                      setSelectedAccount(null);
                    }}
                  >
                    Issued To
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "issued_date" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("issued_date")}
                  >
                    Issued Date
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "payment_method" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("payment_method")}
                  >
                    Payment Method
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "check_number" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("check_number")}
                  >
                    Check Number
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "ref_number" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("ref_number")}
                  >
                    Reference Number
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "amount" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("amount")}
                  >
                    Amount
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div
            className="w-100 mt-3 container-fluid"
            // style={{ maxWidth: "78.5vw" }}
          >
            <Tabs
              transition={false}
              mountOnEnter
              unmountOnExit={false}
              activeKey={activeTab}
              // onSelect={(tab) => setActiveTab(tab)}
              onSelect={(tab) => {
                setActiveTab(tab);
                FilterStore.saveTab(tab);
                pagination.setCurrentPage(1);
              }}
              id="collection-status-tabs"
              className="mb-3"
            >
              <Tab eventKey="pending" title={`Pending (${pendingTabCount})`}>
                <div className="data-table-cell-width">
                  <DataTable
                    columns={sort.sortColumns(columns)}
                    data={tabFilteredData}
                    customStyles={customStyles}
                    conditionalRowStyles={conditionalRowStyles}
                    className="dataTable"
                    {...sort.sortProps}
                  />
                  <PaginationControls {...pagination} />
                </div>
              </Tab>

              <Tab
                eventKey="collected"
                title={`Collected (${collectedTabCount})`}
              >
                <div className="data-table-cell-width">
                  <DataTable
                    columns={sort.sortColumns(columns)}
                    data={tabFilteredData}
                    customStyles={customStyles}
                    conditionalRowStyles={conditionalRowStyles}
                    className="dataTable"
                    {...sort.sortProps}
                  />
                  <PaginationControls {...pagination} />
                </div>
              </Tab>
            </Tabs>
          </div>
        </>
      ) : (
        <div className="no-access">
          <img src={NoAccess} alt="NoAccess" className="no-access-img" />
          <h3>You don't have access to this function.</h3>
        </div>
      )}

      {/* Subject modal for claiming */}
      <Modal
        show={modalSubject}
        onHide={handleCloseModalSubject}
        backdrop="static"
        size="md"
      >
        <Form
          noValidate
          validated={validated}
          onSubmit={(e) => handleClaimSubject(e, "Debit")}
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-primary fw-bold">
              Claiming{" "}
              {transactionNumber
                ? `(${transactionNumber})`
                : `Check #: ${issuedCheckNumber}`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="px-4">
            {/* <Table bordered>
              <thead>
                <tr>
                  <th>Subject 1</th>
                  <th>Subject 2</th>
                  <th>Subject 3</th>
                  {isNotPhp && <th>Foreign Rate</th>}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ padding: "15px" }} className="w-25">
                    <select
                      className="form-select text-truncate"
                      onChange={handleSubject1Change}
                      value={subject1}
                      required
                    >
                      <option value="" selected disabled>
                        Select Account
                      </option>
                      <option value="Account-List">Account-List</option>
                      <option value="Asset Account">Asset Account</option>
                      <option value="Liabilities Account">
                        Liabilities Account
                      </option>
                      <option value="Owner's Equity Account">
                        Owner's Equity Account
                      </option>
                    </select>
                  </td>
                  <td style={{ padding: "15px" }} className="w-25">
                    <select
                      className="form-select"
                      onChange={(e) =>
                        handleSubject2Change(
                          e,
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "data-subject-type"
                          )
                        )
                      }
                      value={subject2}
                      disabled={isSubject2Disabled}
                      required
                    >
                      <option value="" selected>
                        Select Subject 2
                      </option>
                      {subject2DataList.map((option) => (
                        <option
                          key={option.id}
                          value={option.id}
                          data-subject-type={option.subject_type}
                        >
                          {option.subject_name}
                        </option>
                      ))}
                    </select>
                    <Select
                      options={subject2Options}
                      value={subject2}
                      onChange={(selectedOption) =>
                        handleSubject2Change(selectedOption)
                      }
                      placeholder={`Select Subject 2`}
                      styles={themedSelectStyles(subject2, validated)}
                      isDisabled={isSubject2Disabled}
                      required
                      isSearchable
                    />
                  </td>
                  <td style={{ padding: "15px" }} className="w-25">
                    <select
                      className="form-select"
                      onChange={handleSubject3Change}
                      value={subject3}
                      disabled={isSubject3Disabled}
                      required
                    >
                      <option value="" selected>
                        Select Subject 3
                      </option>
                      {subject3DataList.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.account_name}
                        </option>
                      ))}
                    </select>
                    <Select
                      options={subject3Options}
                      value={subject3}
                      onChange={handleSubject3Change}
                      placeholder={`Select Subject 3`}
                      styles={themedSelectStyles(subject3, validated)}
                      isDisabled={isSubject3Disabled}
                      required
                      isSearchable
                    />
                  </td>
                  {isNotPhp && (
                    <td style={{ padding: "15px " }}>
                      <input
                        type="number"
                        id="currency-rate"
                        name="currency_rate"
                        className="form-control"
                        placeholder="Enter Foreign Rate"
                        value={currencyRate}
                        onChange={(e) => setCurrencyRate(e.target.value)}
                        onKeyDown={(e) => {
                          ["-", "e", "+"].includes(e.key) && e.preventDefault();
                        }}
                        min={0}
                        required
                      />
                    </td>
                  )}
                </tr>
              </tbody>
            </Table> */}
            <div className="mb-3">
              <label htmlFor="subject1-claim" className="fw-semibold">
                Step 1 / Subject <span style={{ color: "red" }}>*</span>{" "}
                {isVisibleLiabNote && (
                  <span
                    className="fst-italic text-danger"
                    style={{ fontSize: 9.5 }}
                  >
                    (Please be advised that this liability will result in a
                    deduction from the selected account upon collection)
                  </span>
                )}
              </label>
              <select
                className="form-select text-truncate"
                onChange={handleSubject1Change}
                value={subject1}
                id="subject1-claim"
                required
              >
                {/* <option value="" selected disabled> */}
                <option value="" disabled>
                  Select Account
                </option>
                <option value="Account-List">Account-List</option>
                <option value="Asset Account">Asset Account</option>
                {isFromSalesCollection && (
                  <option value="Liabilities Account">
                    Liabilities Account
                  </option>
                )}
                <option value="Owner's Equity Account" disabled>
                  Owner's Equity Account
                </option>
              </select>
            </div>

            <div className="mb-3">
              <label htmlFor="subject2-claim" className="fw-semibold">
                Step 2 / Subject <span style={{ color: "red" }}>*</span>{" "}
              </label>
              <Select
                options={subject2Options}
                value={subject2}
                id="subject2-claim"
                onChange={(selectedOption) =>
                  handleSubject2Change(selectedOption)
                }
                placeholder={`Select Subject 2`}
                styles={themedSelectStyles(subject2, validated)}
                isDisabled={isSubject2Disabled}
                required
                isSearchable
              />
            </div>

            <div className="mb-3">
              <label htmlFor="subject3-claim" className="fw-semibold">
                Step Subject 3 <span style={{ color: "red" }}>*</span>{" "}
              </label>
              <Select
                options={subject3Options}
                value={subject3}
                id="subject3-claim"
                onChange={handleSubject3Change}
                placeholder={`Select Subject 3`}
                styles={themedSelectStyles(subject3, validated)}
                isDisabled={isSubject3Disabled}
                required
                isSearchable
              />
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="button"
              variant="secondary"
              onClick={handleCloseModalSubject}
            >
              Close
            </Button>
            <Button variant="primary" type="submit">
              Claim
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Confirmation export Modal */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header className="border-0" closeButton>
          <Modal.Title>Confirm Export</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          Are you sure you want to export the data?
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="outline-secondary"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancel
          </Button>
          <CSVLink
            // data={exportToCSV()}
            filename={"export.csv"}
            className="btn btn-primary"
            asyncOnClick={true}
            onClick={(event, done) => {
              setShowConfirmModal(false);
              done();
            }}
          >
            Export
          </CSVLink>
        </Modal.Footer>
      </Modal>

      {/* PDF Modal */}
      <Modal show={printToPdf} size="xl" onHide={() => setPrintToPdf(false)}>
        <div className="position-relative">
          <PDFDownloadLink
            document={<CollectionPdf {...props} />}
            fileName={`Outstanding Receivable.pdf`}
          >
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip
                  id="tooltip-right"
                  className="me-2"
                  style={{ fontSize: "0.8rem" }}
                >
                  Download as{" "}
                  <strong className="text-danger">
                    Outstanding Receivable
                  </strong>
                </Tooltip>
              }
              delay={300}
            >
              <Button
                variant="light"
                className="position-absolute btn btn-light border border-4 border-secondary mb-5 rounded-5"
                style={{ bottom: "7rem", left: "2rem" }}
              >
                <i className="fa-solid fa-download"></i>
              </Button>
            </OverlayTrigger>
          </PDFDownloadLink>
          <PDFViewer style={{ width: "100%", height: "100vh" }}>
            <CollectionPdf {...props} />
          </PDFViewer>
        </div>
      </Modal>

      {/* Currency Rate Modal */}
      <Modal show={show} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Currency Rate</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <label htmlFor="currency-rate" className="mb-2">
              Foreign Rate
            </label>
            <input
              type="number"
              id="currency-rate"
              name="currency_rate"
              className="form-control"
              placeholder="Enter Foreign Rate"
              value={currencyRate}
              onChange={(e) => setCurrencyRate(e.target.value)}
              onKeyDown={(e) => {
                ["-", "e", "+"].includes(e.key) && e.preventDefault();
              }}
              min={0}
              required
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmitForeignRateModal}
          >
            Submit
          </button>
        </Modal.Footer>
      </Modal>

      {/* Receiving Check Modal */}
      <Modal
        show={showReceivingCheckModal}
        onHide={handleCloseReceivingCheckModal}
        backdrop="static"
        size="lg"
      >
        <Form
          noValidate
          validated={validated}
          onSubmit={(e) => handleSubmitReceivingCheck(e)}
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-primary fw-bold">
              Receiving Check
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 px-2 py-0">
              <div className="card border-0">
                <div className="card-body">
                  {/* Transaction Date Field */}
                  <div className="row mb-3">
                    <div className="col-lg">
                      <label htmlFor="transactionDate" className="fw-semibold">
                        Transaction Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="fa-solid fa-calendar-alt"></i>
                        </span>
                        {/* <Form.Control
                          type="date"
                          id="transactionDate"
                          value={loanData.transactionDate}
                          required
                          onChange={(e) =>
                            setLoanData({
                              ...loanData,
                              transactionDate: e.target.value,
                            })
                          }
                          className="rounded"
                        /> */}
                        {/* <div className="flex-grow-1">
                          <DatePicker
                            selected={loanData.transactionDate}
                            onChange={(date) => {
                              dateValidation(
                                date,
                                setLoanData,
                                "Transaction Date",
                                "transactionDate"
                              );
                              setLoanData({
                                ...loanData,
                                transactionDate: date,
                              });
                            }}
                            dateFormat="MMM/dd/yyyy"
                            customInput={<CustomInput />}
                          />
                        </div> */}
                        <div className="flex-grow-1">
                          <DatePicker
                            id="transactionDate"
                            selected={
                              loanData.transactionDate
                                ? new Date(loanData.transactionDate)
                                : null
                            }
                            onChange={handleLoanTransactionDateChange}
                            customInput={<TypedDateInput />}
                            // Month list + year grid header, same as
                            // CustomDatePicker. "Today" goes through the same
                            // change handler so cutoff checks still apply.
                            renderCustomHeader={(headerProps) => (
                              <CustomDatePickerHeader
                                {...headerProps}
                                onToday={handleLoanTransactionDateChange}
                              />
                            )}
                            className="form-control rounded-start-0"
                            wrapperClassName="w-100"
                            dateFormat={DATE_PICKER_FORMATS}
                            strictParsing
                            autoComplete="off"
                            required
                          />
                        </div>
                      </div>
                      {transactionDatePostedCutoff && (
                        <div
                          className="text-danger mt-1"
                          style={{ fontSize: "0.8rem" }}
                        >
                          Transaction date is already in a posted cutoff
                          {transactionDatePostedCutoff.name
                            ? ` (${transactionDatePostedCutoff.name})`
                            : ""}
                          . Please choose another date.
                        </div>
                      )}
                    </div>

                    <div className="col-lg mt-3 mt-lg-0">
                      <label htmlFor="issuedDate" className="fw-semibold">
                        Issued Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="fa-solid fa-calendar-alt"></i>
                        </span>
                        {/* <Form.Control
                          type="date"
                          id="issuedDate"
                          value={loanData.issuedDate}
                          required
                          onChange={(e) =>
                            setLoanData({
                              ...loanData,
                              issuedDate: e.target.value,
                            })
                          }
                          className="rounded"
                        /> */}
                        {/* <div className="flex-grow-1">
                          <DatePicker
                            selected={loanData.issuedDate}
                            onChange={(date) => {
                              dateValidation(
                                date,
                                setLoanData,
                                "Issued Date",
                                "issuedDate"
                              );
                              setLoanData({
                                ...loanData,
                                issuedDate: date,
                              });
                            }}
                            dateFormat="MMM/dd/yyyy"
                            customInput={<CustomInput />}
                          />
                        </div> */}
                        <div className="flex-grow-1">
                          <DatePicker
                            id="issuedDate"
                            selected={
                              loanData.issuedDate
                                ? new Date(loanData.issuedDate)
                                : null
                            }
                            onChange={handleLoanIssuedDateChange}
                            onChangeRaw={handleLoanIssuedDateRaw}
                            customInput={<TypedDateInput />}
                            renderCustomHeader={(headerProps) => (
                              <CustomDatePickerHeader
                                {...headerProps}
                                onToday={handleLoanIssuedDateChange}
                              />
                            )}
                            className="form-control rounded-start-0"
                            wrapperClassName="w-100"
                            dateFormat={DATE_PICKER_FORMATS}
                            strictParsing
                            autoComplete="off"
                            required
                            minDate={
                              loanData.transactionDate
                                ? new Date(loanData.transactionDate)
                                : null
                            }
                          />
                        </div>
                      </div>
                      {issuedDateError && (
                        <div
                          className="text-danger mt-1"
                          style={{ fontSize: "0.8rem" }}
                        >
                          {issuedDateError}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Currency Field */}
                  <div className="row mb-3">
                    <div className="col-sm">
                      <label htmlFor="currency" className="fw-semibold">
                        Currency <span style={{ color: "red" }}>*</span>
                      </label>
                      <Form.Select
                        value={loanData.currency_id}
                        required
                        onChange={(e) =>
                          setLoanData({
                            ...loanData,
                            subject2: "",
                            subject3: "",
                            currency_id: e.target.value,
                            currency_name:
                              e.target.options[e.target.selectedIndex].text,
                          })
                        }
                      >
                        {/* <option value="" selected disabled> */}
                        <option value="" disabled>
                          Select Currency
                        </option>
                        {currencyList.map((currency) => (
                          <option key={currency.id} value={currency.id}>
                            {currency.currency_name}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                    <div className="col-sm mt-3 mt-sm-0">
                      <label htmlFor="checkNumber" className="fw-semibold">
                        Check Number <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="fa-solid fa-file-invoice"></i>
                        </span>
                        <Form.Control
                          type="text"
                          id="checkNumber"
                          value={loanData.checkNumber}
                          required
                          onChange={(e) =>
                            setLoanData({
                              ...loanData,
                              checkNumber: e.target.value,
                            })
                          }
                          placeholder="Enter check number"
                          className="rounded z-0"
                          maxLength={15}
                        />
                      </div>
                      <CheckNumberError value={loanData.checkNumber} />
                    </div>
                  </div>

                  {/* Subject Fields  */}
                  <div className="row mb-3">
                    <div className="col-sm">
                      <label htmlFor="subject1" className="fw-semibold">
                        Step 1 / Subject (For Loan){" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Form.Select
                        id="subject1"
                        value={loanData.subject1}
                        disabled={loanData.currency_id === ""}
                        required
                        onChange={(e) => {
                          setLoanData({
                            ...loanData,
                            subject1: e.target.value,
                            subject2: "",
                            subject3: "",
                          });
                          fetchSubject2Data(e.target.value);
                        }}
                        className="rounded"
                      >
                        <option value="" disabled>
                          Select Subject 1
                        </option>
                        <option value="Owner's Equity Account" disabled>
                          Owner's Equity Account
                        </option>
                        <option value="Account-List" disabled>
                          Account-List
                        </option>
                        <option value="Asset Account" disabled>
                          Asset Account
                        </option>
                        <option value="Liabilities Account">
                          Liabilities Account
                        </option>
                      </Form.Select>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-sm">
                      <label htmlFor="subject2" className="fw-semibold">
                        Step 2 / Subject <span style={{ color: "red" }}>*</span>
                      </label>
                      {/* <Form.Select
                        id="subject2"
                        value={loanData.subject2}
                        disabled={loanData.currency_id === ""}
                        required
                        onChange={(e) => {
                          setLoanData({
                            ...loanData,
                            subject2: e.target.value,
                            subject3: "",
                            subject2_name:
                              e.target.options[e.target.selectedIndex].text,
                          });
                          fetchSubject3Data(e.target.value);
                        }}
                        className="rounded"
                      >
                        <option value="" disabled>
                          Select Subject 2
                        </option>
                        {subject2LoanDataList.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.subject_name}
                          </option>
                        ))}
                      </Form.Select> */}
                      <Select
                        options={subject2LoanOptions}
                        value={loanData.subject2}
                        onChange={(selectedOption) => {
                          setLoanData({
                            ...loanData,
                            subject2: selectedOption,
                            subject3: "",
                            subject2_name: selectedOption?.label,
                            // e.target.options[e.target.selectedIndex].text,
                          });
                          fetchSubject3Data(selectedOption?.value);
                        }}
                        placeholder={`Select Subject 2`}
                        styles={{
                          ...themedSelectStyles(loanData.subject2, validated),
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        menuPortalTarget={document.body}
                        isDisabled={loanData.currency_id === ""}
                        required
                        isSearchable
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-sm">
                      <label htmlFor="subject3" className="fw-semibold">
                        Step 3 / Subject <span style={{ color: "red" }}>*</span>
                      </label>
                      {/* <Form.Select
                        id="subject3"
                        value={loanData.subject3}
                        disabled={
                          loanData.currency_id === "" ||
                          loanData.subject2 === ""
                        }
                        required
                        onChange={(e) =>
                          setLoanData({
                            ...loanData,
                            subject3: e.target.value,
                            subject3_name:
                              e.target.options[e.target.selectedIndex].text,
                          })
                        }
                        className="rounded"
                      >
                        <option value="" disabled>
                          Select Subject 3
                        </option>
                        {subject3LoanDataList
                          .filter(
                            (option) =>
                              option.currency_id === loanData.currency_id
                          )
                          .map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.account_name}
                            </option>
                          ))}
                      </Form.Select> */}
                      <Select
                        options={subject3LoanOptions}
                        value={loanData.subject3}
                        onChange={(selectedOption) =>
                          setLoanData({
                            ...loanData,
                            subject3: selectedOption,
                            subject3_name: selectedOption?.label,
                            // e.target.options[e.target.selectedIndex].text,
                          })
                        }
                        onMenuOpen={() => {
                          if (subject3LoanOptions.length === 0) {
                            swal({
                              icon: "warning",
                              title: "No Account Found",
                              text: "There is no account associated with the selected currency. Please create one before proceeding.",
                            });

                            setIsMenuOpen(false);
                          } else {
                            setIsMenuOpen(true);
                          }
                        }}
                        onMenuClose={() => setIsMenuOpen(false)}
                        menuIsOpen={isMenuOpen}
                        placeholder={`Select Subject 3`}
                        styles={{
                          ...themedSelectStyles(loanData.subject3, validated),
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        menuPortalTarget={document.body}
                        isDisabled={
                          loanData.currency_id === "" ||
                          loanData.subject2 === ""
                        }
                        required
                        isSearchable
                      />
                    </div>
                  </div>

                  {/* Amount Field */}
                  <div className="row mb-3">
                    <div className="col-sm">
                      <label htmlFor="amount" className="fw-semibold">
                        Sum Amount <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">
                          {loanData.currency_name}
                        </span>
                        <Form.Control
                          type="text"
                          id="amount"
                          value={loanData.amount}
                          required
                          // onChange={(e) =>
                          //   setLoanData({
                          //     ...loanData,
                          //     amount: e.target.value,
                          //   })
                          // }
                          onChange={handleLoanAmount}
                          placeholder="Enter amount"
                          className="rounded"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Remarks Field */}
                  <div className="row mb-3">
                    <div className="col-sm">
                      <label htmlFor="remarks" className="fw-semibold">
                        Remarks
                      </label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        id="remarks"
                        value={loanData.remarks}
                        onChange={(e) =>
                          setLoanData({
                            ...loanData,
                            remarks: e.target.value,
                          })
                        }
                        placeholder="Enter remarks (optional)"
                        className="rounded"
                        maxLength={255}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="button"
              variant="secondary"
              onClick={handleCloseReceivingCheckModal}
              className="rounded"
            >
              Close
            </Button>
            <Button
              variant="primary"
              type="submit"
              className="rounded"
              disabled={!!transactionDatePostedCutoff}
              title={
                transactionDatePostedCutoff
                  ? "Transaction date is already in a posted cutoff"
                  : undefined
              }
            >
              Save To
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Pay Date Modal — shown before Collect proceeds */}
      <Modal
        show={showDateModal}
        onHide={() => setShowDateModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Claim Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-2 text-muted" style={{ fontSize: "0.875rem" }}>
            Please pick a claim date before proceeding with the collection.
          </p>
          <Form.Label>Claim Date</Form.Label>
          <DatePicker
            selected={selectedClaimDate || null}
            onChange={(date) => {
              setSelectedClaimDate(date);
              setClaimDateError("");
            }}
            onChangeRaw={handleClaimDateRaw}
            className="form-control"
            placeholderText="MM/DD/YY"
            dateFormat="MM/dd/yy"
            strictParsing
            isClearable
            autoFocus
            minDate={minClaimDate}
          />
          {claimDateError && (
            <div className="text-danger mt-1" style={{ fontSize: "0.8rem" }}>
              {claimDateError}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDateModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleDateConfirm}>
            Confirm &amp; Collect
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Collection;
